(function (host, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (host && host.document) { host.DaisySoapGiftNote = api; api.boot(host); }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var defaults = {
    add: 'Add note — £1.50', save: 'Save message', remove: 'Remove note', adding: 'Adding your note…',
    saving: 'Saving your message…', removing: 'Removing your note…', required: 'Write your message first.',
    tooLong: 'Keep your message to 150 characters.', saved: 'Your handwritten note is saved.',
    removed: 'Your handwritten note has been removed.', error: 'Your note could not be saved. Please try again.',
    review: 'We could not confirm the change. Review your basket before trying again.',
    unavailable: 'The handwritten note is currently unavailable.', printedPresent: 'A gift note is already in your basket.',
    noSoap: 'Add a Soul Soap before adding this note.', loading: 'Checking your basket…', count: '{count} / 150'
  };
  function id(value) { return Number.isSafeInteger(Number(value)) && Number(value) > 0; }
  function message(value) { return String(value == null ? '' : value).replace(/\r\n?/g, '\n').trim(); }
  function validateMessage(value) { var text = message(value); return !text ? 'required' : text.length > 150 ? 'tooLong' : ''; }
  function validateConfig(config) {
    return !!(config && id(config.variantId) && (!config.productId || id(config.productId)) &&
      /^[a-z0-9][a-z0-9-]*$/.test(config.productHandle || '') && Number(config.price) === 150 && config.currency === 'GBP' &&
      /^\/(?!\/)(?:[a-zA-Z0-9_-]+\/)*$/.test(config.root || '') &&
      (!config.cartUrl || /^\/(?!\/)[^\\]*$/.test(config.cartUrl)) &&
      Array.isArray(config.soapProductIds) && config.soapProductIds.length > 0 && config.soapProductIds.every(id) && id(config.printedNoteVariantId));
  }
  function lines(cart) { return cart && Array.isArray(cart.items) ? cart.items : []; }
  function variant(item) { return Number(item.variant_id || item.id); }
  function inspectCart(cart, config) {
    var notes = lines(cart).filter(function (item) { return Number(item.quantity) > 0 && variant(item) === Number(config.variantId); });
    function contains(item, predicate) {
      return predicate(item) || (item.item_components || []).some(function (child) { return contains(child, predicate); });
    }
    var live = lines(cart).filter(function (item) { return Number(item.quantity) > 0; });
    return { notes: notes, note: notes.length === 1 ? notes[0] : null, duplicate: notes.length > 1,
      printed: live.some(function (item) { return contains(item, function (child) { return variant(child) === Number(config.printedNoteVariantId); }); }),
      eligible: cart && cart.currency === 'GBP' && live.some(function (item) { return contains(item, function (child) { return config.soapProductIds.some(function (value) { return Number(value) === Number(child.product_id); }); }); }) };
  }
  function verifyProduct(product, config) {
    return !!(product && product.handle === config.productHandle && (!config.productId || Number(product.id) === Number(config.productId)) &&
      Array.isArray(product.variants) && product.variants.some(function (v) { return Number(v.id) === Number(config.variantId) && v.available === true && Number(v.price) === 150; }));
  }
  function buildItem(config, value, existing) {
    var error = validateMessage(value);
    if (!validateConfig(config) || error) throw new Error(error || 'unavailable');
    return { id: Number(config.variantId), quantity: 1, properties: Object.assign({}, existing && existing.properties || {}, {
      'Gift note': message(value), '_Daisy gift note': 'handwritten'
    }) };
  }
  function matches(cart, config, expected) {
    var state = inspectCart(cart, config);
    if (expected === null) return state.notes.length === 0;
    return !!(state.note && Number(state.note.quantity) === 1 && state.note.properties &&
      state.note.properties['Gift note'] === expected && state.note.properties['_Daisy gift note'] === 'handwritten');
  }
  function boot(win) {
    var doc = win.document;
    if (doc.__daisySoapGiftNote) return doc.__daisySoapGiftNote;
    var root, binding, config, labels, state, transport, timer, version = 0;
    var draft = '', saved = '', dirty = false, busy = false, locked = false, notice = '', replay = null, pendingCheckout = null;
    var expressState = new Map(), bindings = new WeakMap();
    function hideExpress(hide) {
      Array.prototype.forEach.call(doc.querySelectorAll('.dm-basket-express'), function (node) {
        if (hide) { if (!expressState.has(node)) expressState.set(node, node.hidden); node.hidden = true; }
        else if (expressState.has(node)) { node.hidden = expressState.get(node); expressState.delete(node); }
      });
      expressState.forEach(function (_, node) { if (node.isConnected === false) expressState.delete(node); });
    }
    function activeCurrency() { return !(win.Shopify && win.Shopify.currency && win.Shopify.currency.active && win.Shopify.currency.active !== 'GBP'); }
    function render() {
      hideExpress(busy || locked || (dirty && (!!message(draft) || state && !!state.note)));
      if (!root || !binding) return;
      var exists = state && !!state.note;
      root.hidden = !state || !exists && !dirty && (!state.eligible || state.printed);
      root.setAttribute('data-gift-note-added', String(!!exists)); root.setAttribute('aria-busy', String(busy));
      binding.message.disabled = busy || locked;
      binding.save.disabled = busy || locked || !state || state.duplicate || (!exists && (!state.eligible || state.printed)) || !!validateMessage(draft) || (exists && !dirty && Number(state.note.quantity) === 1);
      binding.save.textContent = busy ? notice : exists ? labels.save : labels.add;
      binding.remove.hidden = !exists; binding.remove.disabled = busy || locked;
      binding.remove.textContent = labels.remove;
      binding.count.textContent = labels.count.replace('{count}', String(draft.length));
      binding.status.textContent = notice; binding.status.hidden = !notice;
    }
    function fail(text, lock) {
      busy = false; pendingCheckout = null; locked = locked || !!lock; notice = text;
      if (root && root.isConnected === false) bind(doc.querySelector('[data-soap-gift-note]'));
      if (binding && binding.details) binding.details.open = true;
      render(); return false;
    }
    function bind(candidate) {
      if (!candidate) { root = null; binding = null; return false; }
      if (candidate === root && binding) return true;
      var next = bindings.get(candidate);
      if (!next) {
        var parsed;
        try { parsed = JSON.parse(candidate.querySelector('[data-soap-gift-note-config]').textContent); } catch (_) { return false; }
        if (!validateConfig(parsed)) return false;
        next = { config: parsed, message: candidate.querySelector('[data-gift-note-message]'), count: candidate.querySelector('[data-gift-note-count]'),
          save: candidate.querySelector('[data-gift-note-save]'), remove: candidate.querySelector('[data-gift-note-remove]'),
          status: candidate.querySelector('[data-gift-note-status]'), details: candidate.querySelector('[data-gift-note-details]') };
        if (!next.message || !next.count || !next.save || !next.remove || !next.status) return false;
        bindings.set(candidate, next);
        next.message.maxLength = 150;
        next.message.addEventListener('input', function () {
          if (candidate !== root || busy || locked) return;
          draft = next.message.value; dirty = message(draft) !== saved; notice = ''; render();
        });
        candidate.addEventListener('click', function (event) {
          var button = event.target.closest('[data-gift-note-save],[data-gift-note-remove]');
          if (!button || !candidate.contains(button) || candidate !== root) return;
          event.preventDefault();
          if (!button.disabled) mutate(button.hasAttribute('data-gift-note-remove') ? 'remove' : 'save');
        });
      }
      root = candidate; binding = next; config = next.config; labels = Object.assign({}, defaults, config.labels || {});
      if (dirty || busy || locked) binding.message.value = draft;
      else draft = binding.message.value || '';
      render(); return true;
    }
    function request(path, body) {
      var options = { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } };
      if (body) { options.method = 'POST'; options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(body); }
      return win.fetch(config.root + path, options).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok) { var error = new Error(labels.error); error.explicit = response.status >= 400 && response.status < 500; throw error; }
          return data;
        });
      });
    }
    function adopt(cart, preserveDraft) {
      state = inspectCart(cart, config);
      saved = state.note && message(state.note.properties && state.note.properties['Gift note']) || '';
      if (!preserveDraft) { draft = saved; dirty = false; if (binding) binding.message.value = draft; }
      else dirty = message(draft) !== saved;
      if (state.duplicate) { locked = true; notice = labels.review; }
      if (binding && state.note && binding.details && !preserveDraft) binding.details.open = true;
      render();
    }
    function refresh() {
      if (busy || locked) return Promise.resolve();
      if (!bind(doc.querySelector('[data-soap-gift-note]'))) { hideExpress(false); return Promise.resolve(); }
      var revision = ++version;
      return request('cart.js').then(function (cart) {
        if (revision !== version || busy || locked) return;
        adopt(cart, dirty);
      }).catch(function () { if (revision === version) { state = null; render(); } });
    }
    function change(item, desired, text) {
      var expected = desired.quantity === 0 ? null : text;
      return request('cart/change.js', desired).then(function (cart) {
        if (!matches(cart, config, expected)) throw new Error(labels.review);
        return cart;
      }).catch(function (error) {
        return request('cart.js').then(function (cart) {
          if (matches(cart, config, expected)) return cart;
          var current = inspectCart(cart, config);
          var unchanged = current.note && current.note.key === item.key && Number(current.note.quantity) === Number(item.quantity) &&
            JSON.stringify(current.note.properties || {}) === JSON.stringify(item.properties || {});
          if (error.explicit && unchanged) throw error;
          var uncertain = new Error(labels.review); uncertain.reviewCart = true; throw uncertain;
        }, function () { var uncertain = new Error(labels.review); uncertain.reviewCart = true; throw uncertain; });
      });
    }
    function finish(cart, removed) {
      if (root && root.isConnected === false) bind(doc.querySelector('[data-soap-gift-note]'));
      adopt(cart, false); busy = false; notice = removed ? labels.removed : labels.saved; render();
      var checkout = pendingCheckout; pendingCheckout = null;
      if (checkout && checkout.isConnected !== false) {
        replay = checkout;
        try { checkout.click(); } finally { replay = null; }
      } else win.location.assign(config.cartUrl || config.root + 'cart');
      return true;
    }
    function mutate(action) {
      if (busy || locked || !binding || !activeCurrency()) return Promise.resolve(false);
      draft = binding.message.value; dirty = message(draft) !== saved;
      var text = message(draft), invalid = action === 'save' && validateMessage(text);
      if (invalid) { if (binding.message.focus) binding.message.focus(); return Promise.resolve(fail(labels[invalid])); }
      busy = true; version++; notice = action === 'remove' ? labels.removing : state && state.note ? labels.saving : labels.adding; render();
      var wrote = false, confirmedWrite = false;
      return request('cart.js').then(function (cart) {
        var current = inspectCart(cart, config); state = current;
        if (current.duplicate) { var duplicate = new Error(labels.review); duplicate.reviewCart = true; throw duplicate; }
        if (action === 'remove') {
          if (!current.note) return cart;
          wrote = true; return change(current.note, { id: current.note.key, quantity: 0 }, null);
        }
        if (!current.note && current.printed) throw new Error(labels.printedPresent);
        if (!current.note && !current.eligible) throw new Error(labels.noSoap);
        if (matches(cart, config, text)) return cart;
        return request('products/' + config.productHandle + '.js').then(function (product) {
          if (!verifyProduct(product, config)) throw new Error(labels.unavailable);
          var item = buildItem(config, text, current.note);
          if (current.note) {
            wrote = true; return change(current.note, { id: current.note.key, quantity: 1, properties: item.properties }, text);
          }
          if (!win.DaisyCartSubmit || !win.DaisyCartSubmit.create) throw new Error(labels.unavailable);
          if (!transport) transport = win.DaisyCartSubmit.create({ root: config.root, fetch: win.fetch.bind(win) });
          wrote = true;
          return transport.add([item]).then(function () { confirmedWrite = true; return request('cart.js'); }).then(function (updated) {
            if (!matches(updated, config, text)) { var uncertain = new Error(labels.review); uncertain.reviewCart = true; throw uncertain; }
            return updated;
          });
        });
      }).then(function (cart) { return finish(cart, action === 'remove'); }).catch(function (error) {
        var uncertain = error.reviewCart || confirmedWrite || (wrote && !busy);
        return fail(uncertain ? labels.review : Object.keys(labels).some(function (key) { return labels[key] === error.message; }) ? error.message : labels.error, uncertain);
      });
    }
    function checkoutGuard(event) {
      var button = event.type === 'submit' ? event.submitter : event.target.closest && event.target.closest('#cart-checkout,[name="checkout"]');
      if (!button || button === replay || !binding || !root || root.isConnected === false) return;
      draft = binding.message.value; dirty = message(draft) !== saved;
      if (!busy && !locked && !(dirty && (message(draft) || state && state.note))) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (locked) { fail(labels.review, true); return; }
      pendingCheckout = button;
      if (!busy) mutate('save');
    }
    function schedule() { win.clearTimeout(timer); timer = win.setTimeout(refresh, 180); }
    function start() {
      refresh();
      win.addEventListener('click', checkoutGuard, true);
      win.addEventListener('submit', checkoutGuard, true);
      ['cart-update', 'cart:updated', 'cart:refresh', 'shopify:section:load'].forEach(function (name) { doc.addEventListener(name, schedule); });
      win.addEventListener('pageshow', function (event) { if (event.persisted) refresh(); });
      if (win.MutationObserver) {
        var observer = new win.MutationObserver(function (records) {
          if (busy || locked) return;
          if (doc.querySelector('[data-soap-gift-note]') !== root || records.some(function (record) {
            var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
            return target && target.closest && !target.closest('[data-soap-gift-note]') && target.closest('#main-cart-items');
          })) schedule();
        });
        observer.observe(doc.body, { childList: true, subtree: true });
      }
    }
    var controller = { refresh: refresh, mutate: mutate };
    doc.__daisySoapGiftNote = controller;
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start, { once: true }); else start();
    return controller;
  }
  return { message: message, validateMessage: validateMessage, validateConfig: validateConfig, inspectCart: inspectCart,
    verifyProduct: verifyProduct, buildItem: buildItem, matches: matches, boot: boot };
});
